// extracted by mini-css-extract-plugin
export default {"welcome-message__title-overline":"WelcomeMessage_welcome-message__title-overline__GGzid","welcome-message__subtitle":"WelcomeMessage_welcome-message__subtitle__cA6QT"};